<template>
  <va-create-layout>
    <map-form :title="title" :item="item"></map-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
